// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MedicalProblemPopup-module__font-s-10___YPlx4 {
  font-size: 10px !important;
}

.MedicalProblemPopup-module__font-s-12___cq9Fn {
  font-size: 12px !important;
}

.MedicalProblemPopup-module__font-s-13___Fdf6N {
  font-size: 13px !important;
}

.MedicalProblemPopup-module__font-s-14___QWgOZ {
  font-size: 14px !important;
}

.MedicalProblemPopup-module__font-s-15___A5iGT {
  font-size: 15px !important;
}

.MedicalProblemPopup-module__font-s-16___cl4Cw {
  font-size: 16px !important;
}

.MedicalProblemPopup-module__font-s-18___eBVfG {
  font-size: 18px !important;
}

.MedicalProblemPopup-module__font-s-20___emEcS {
  font-size: 20px !important;
}

.MedicalProblemPopup-module__font-s-22___W5fTm {
  font-size: 22px !important;
}

.MedicalProblemPopup-module__font-s-28___sTtrM {
  font-size: 28px !important;
}

.MedicalProblemPopup-module__font-w-400___x2Tz8 {
  font-weight: 400 !important;
}

.MedicalProblemPopup-module__font-w-500___SFJap {
  font-weight: 500 !important;
}

.MedicalProblemPopup-module__font-w-600___S8OX6 {
  font-weight: 600 !important;
}

.MedicalProblemPopup-module__font-w-700___ffwWb {
  font-weight: 700 !important;
}

.MedicalProblemPopup-module__p-5___U9szd {
  padding: 5px !important;
}

.MedicalProblemPopup-module__p-12___s97tM {
  padding: 12px !important;
}

.MedicalProblemPopup-module__p-16___z2buJ {
  padding: 16px !important;
}

.MedicalProblemPopup-module__p-30___Hg4e7 {
  padding: 30px !important;
}

.MedicalProblemPopup-module__p-b-0___ufGGw {
  padding-bottom: 0 !important;
}

.MedicalProblemPopup-module__p-b-5___T3Tyl {
  padding-bottom: 5px !important;
}

.MedicalProblemPopup-module__p-b-10___QyVZg {
  padding-bottom: 10px !important;
}

.MedicalProblemPopup-module__p-b-12___NXY7E {
  padding-bottom: 12px !important;
}

.MedicalProblemPopup-module__p-b-16___ZlIPl {
  padding-bottom: 16px !important;
}

.MedicalProblemPopup-module__p-b-18___rL2Qt {
  padding-bottom: 18px !important;
}

.MedicalProblemPopup-module__p-b-20___agklF {
  padding-bottom: 20px !important;
}

.MedicalProblemPopup-module__p-b-25___hMexT {
  padding-bottom: 25px !important;
}

.MedicalProblemPopup-module__p-b-30___ll_Yd {
  padding-bottom: 30px !important;
}

.MedicalProblemPopup-module__p-b-50___aWlta {
  padding-bottom: 50px !important;
}

.MedicalProblemPopup-module__p-t-0___mkenR {
  padding-top: 0 !important;
}

.MedicalProblemPopup-module__p-t-12___cpvfX {
  padding-top: 12px !important;
}

.MedicalProblemPopup-module__p-t-16___ILABN {
  padding-top: 16px !important;
}

.MedicalProblemPopup-module__p-t-18___fFK0G {
  padding-top: 18px !important;
}

.MedicalProblemPopup-module__p-t-20___v1DcL {
  padding-top: 20px !important;
}

.MedicalProblemPopup-module__p-t-30___NiMdm {
  padding-top: 30px !important;
}

.MedicalProblemPopup-module__p-t-40___cWY7s {
  padding-top: 40px !important;
}

.MedicalProblemPopup-module__p-t-50___fj0_H {
  padding-top: 50px !important;
}

.MedicalProblemPopup-module__p-l-20___YbfT5 {
  padding-left: 20px !important;
}

.MedicalProblemPopup-module__p-l-30___mUGns {
  padding-left: 30px !important;
}

.MedicalProblemPopup-module__p-l-40___a9ISR {
  padding-left: 40px !important;
}

.MedicalProblemPopup-module__p-r-16___zsfa0 {
  padding-right: 16px !important;
}

.MedicalProblemPopup-module__p-r-20___fA956 {
  padding-right: 20px !important;
}

.MedicalProblemPopup-module__p-r-30___hSm15 {
  padding-right: 30px !important;
}

.MedicalProblemPopup-module__p-r-50___NjMOQ {
  padding-right: 50px !important;
}

.MedicalProblemPopup-module__p-r-60___fSuEi {
  padding-right: 60px !important;
}

.MedicalProblemPopup-module__m-b-1___wotsX {
  margin-bottom: 1px !important;
}

.MedicalProblemPopup-module__m-b-2___AQzp8 {
  margin-bottom: 2px !important;
}

.MedicalProblemPopup-module__m-b-6___fNGf_ {
  margin-bottom: 6px !important;
}

.MedicalProblemPopup-module__m-b-8___IosPo {
  margin-bottom: 8px !important;
}

.MedicalProblemPopup-module__m-b-10___LYdr8 {
  margin-bottom: 10px !important;
}

.MedicalProblemPopup-module__m-b-14___fp6c4 {
  margin-bottom: 14px !important;
}

.MedicalProblemPopup-module__m-b-16____4kTB {
  margin-bottom: 16px !important;
}

.MedicalProblemPopup-module__m-b-20___vEx5s {
  margin-bottom: 20px !important;
}

.MedicalProblemPopup-module__m-b-22___klrzw {
  margin-bottom: 22px !important;
}

.MedicalProblemPopup-module__m-b-24___XDHAF {
  margin-bottom: 24px !important;
}

.MedicalProblemPopup-module__m-b-30___X5XIB {
  margin-bottom: 30px !important;
}

.MedicalProblemPopup-module__m-b-32___GqtnS {
  margin-bottom: 32px !important;
}

.MedicalProblemPopup-module__m-b-40___jUrer {
  margin-bottom: 40px !important;
}

.MedicalProblemPopup-module__m-t-2____lHkg {
  margin-top: 2px !important;
}

.MedicalProblemPopup-module__m-t-3___HcS6E {
  margin-top: 3px !important;
}

.MedicalProblemPopup-module__m-t-4___nL32O {
  margin-top: 4px !important;
}

.MedicalProblemPopup-module__m-t-5___99bQN {
  margin-top: 5px !important;
}

.MedicalProblemPopup-module__m-t-8___g56Iz {
  margin-top: 8px !important;
}

.MedicalProblemPopup-module__m-t-10___zbdNC {
  margin-top: 10px !important;
}

.MedicalProblemPopup-module__m-t-15___xFmG8 {
  margin-top: 15px !important;
}

.MedicalProblemPopup-module__m-t-16___ek40z {
  margin-top: 16px !important;
}

.MedicalProblemPopup-module__m-t-20___yxppV {
  margin-top: 20px !important;
}

.MedicalProblemPopup-module__m-t-22___FzPat {
  margin-top: 22px !important;
}

.MedicalProblemPopup-module__m-t-30___mcnRa {
  margin-top: 30px !important;
}

.MedicalProblemPopup-module__m-t-32___UiOY0 {
  margin-top: 32px !important;
}

.MedicalProblemPopup-module__m-l-auto___dbDWu {
  margin-left: auto !important;
}

.MedicalProblemPopup-module__m-l-4___ke4cR {
  margin-left: 4px !important;
}

.MedicalProblemPopup-module__m-l-5___rItU7 {
  margin-left: 5px !important;
}

.MedicalProblemPopup-module__m-l-6___znOJB {
  margin-left: 6px !important;
}

.MedicalProblemPopup-module__m-l-8___V7DHM {
  margin-left: 8px !important;
}

.MedicalProblemPopup-module__m-l-10___xHdYU {
  margin-left: 10px !important;
}

.MedicalProblemPopup-module__m-l-16___ygEca {
  margin-left: 16px !important;
}

.MedicalProblemPopup-module__m-l-20___qm7JZ {
  margin-left: 20px !important;
}

.MedicalProblemPopup-module__m-l-24___MliXi {
  margin-left: 24px !important;
}

.MedicalProblemPopup-module__m-l-30___PaEKW {
  margin-left: 30px !important;
}

.MedicalProblemPopup-module__m-l-35___VbvoL {
  margin-left: 35px !important;
}

.MedicalProblemPopup-module__m-l-40___UsRim {
  margin-left: 40px !important;
}

.MedicalProblemPopup-module__m-r-8___t9Mbt {
  margin-right: 8px !important;
}

.MedicalProblemPopup-module__m-r-10___QEE_3 {
  margin-right: 10px !important;
}

.MedicalProblemPopup-module__m-r-16___ZajIW {
  margin-right: 16px !important;
}

.MedicalProblemPopup-module__m-r-20___Y3VzB {
  margin-right: 20px !important;
}

.MedicalProblemPopup-module__m-r-24___djewP {
  margin-right: 24px !important;
}

.MedicalProblemPopup-module__m-r-30___Zwiv5 {
  margin-right: 30px !important;
}

.MedicalProblemPopup-module__m-r-40___NCrzb {
  margin-right: 40px !important;
}

.MedicalProblemPopup-module__border-r-3___fzTXP {
  border-radius: 3px !important;
}

.MedicalProblemPopup-module__border-r-4___PAo9U {
  border-radius: 4px !important;
}

.MedicalProblemPopup-module__border-r-6___arN3L {
  border-radius: 6px !important;
}

.MedicalProblemPopup-module__border-r-10___qNO4Y {
  border-radius: 10px !important;
}

.MedicalProblemPopup-module__border-r-12___s_lIJ {
  border-radius: 12px !important;
}

.MedicalProblemPopup-module__border-r-16___h5zjx {
  border-radius: 16px !important;
}

.MedicalProblemPopup-module__border-r-50___TLJjj {
  border-radius: 50% !important;
}

.MedicalProblemPopup-module__primary-border___XnWD5 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalProblemPopup-module__primary-border-b___FSive {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalProblemPopup-module__primary-border-t___mR7C7 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalProblemPopup-module__primary-border-l___Ym7Dz {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalProblemPopup-module__primary-border-r___X5zvl {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalProblemPopup-module__secondary-border___u8xC7 {
  border: 1px solid #637768;
}

.MedicalProblemPopup-module__secondary-border-b___q9sd_ {
  border-bottom: 1px solid #637768;
}

.MedicalProblemPopup-module__secondary-border-t___t3CCK {
  border-top: 1px solid #637768;
}

.MedicalProblemPopup-module__secondary-border-l___ABZjI {
  border-left: 1px solid #637768;
}

.MedicalProblemPopup-module__secondary-border-r___xU5fR {
  border-right: 1px solid #637768;
}

.MedicalProblemPopup-module__gap-0___MlNEm {
  gap: 0 !important;
}

.MedicalProblemPopup-module__gap-2___KFMrz {
  gap: 2px !important;
}

.MedicalProblemPopup-module__gap-4___EZvr6 {
  gap: 4px !important;
}

.MedicalProblemPopup-module__gap-5___Wx6lF {
  gap: 5px !important;
}

.MedicalProblemPopup-module__gap-6___dD0CU {
  gap: 6px !important;
}

.MedicalProblemPopup-module__gap-8____n72u {
  gap: 8px !important;
}

.MedicalProblemPopup-module__gap-10___INw7x {
  gap: 10px !important;
}

.MedicalProblemPopup-module__gap-12___yFn4a {
  gap: 12px !important;
}

.MedicalProblemPopup-module__gap-14___WEX9A {
  gap: 14px !important;
}

.MedicalProblemPopup-module__gap-16___spqrq {
  gap: 16px !important;
}

.MedicalProblemPopup-module__gap-18___ryDnL {
  gap: 18px !important;
}

.MedicalProblemPopup-module__gap-20___MXFBZ {
  gap: 20px !important;
}

.MedicalProblemPopup-module__gap-24___YdNQU {
  gap: 24px !important;
}

.MedicalProblemPopup-module__gap-26___BdPgg {
  gap: 26px !important;
}

.MedicalProblemPopup-module__gap-30___rlOki {
  gap: 30px !important;
}

.MedicalProblemPopup-module__gap-32___JAMyv {
  gap: 32px !important;
}

.MedicalProblemPopup-module__gap-40___s6_m7 {
  gap: 40px !important;
}

.MedicalProblemPopup-module__gap-50___S4qlp {
  gap: 50px !important;
}

.MedicalProblemPopup-module__flex-1___sP7eh {
  flex: 1;
}

.MedicalProblemPopup-module__flex-none___nDAIh {
  flex: none !important;
}

.MedicalProblemPopup-module__flex-column___CpjnU {
  display: flex;
  flex-direction: column !important;
}

.MedicalProblemPopup-module__flex-row___KoMAQ {
  display: flex;
  flex-direction: row !important;
}

.MedicalProblemPopup-module__vertically-centered___tFMjH {
  display: flex;
  align-items: center !important;
}

.MedicalProblemPopup-module__horizontally-centered___LADrO {
  display: flex;
  justify-content: center !important;
}

.MedicalProblemPopup-module__horizontally-end___xSCay {
  display: flex;
  justify-content: end !important;
}

.MedicalProblemPopup-module__vertically-start___fgaBt {
  display: flex;
  align-items: start !important;
}

.MedicalProblemPopup-module__space-between___kG3kb {
  display: flex;
  justify-content: space-between !important;
}

.MedicalProblemPopup-module__flex-wrap___UWxy4 {
  flex-wrap: wrap !important;
}

.MedicalProblemPopup-module__height-100___e33Tu {
  height: 100%;
}

.MedicalProblemPopup-module__width-50___vo0eU {
  width: 50% !important;
}

.MedicalProblemPopup-module__width-100___noaVO {
  width: 100%;
}

.MedicalProblemPopup-module__cursor-pointer___i8X3e {
  cursor: pointer;
}

.MedicalProblemPopup-module__cursor-not-allowed___x0e0g {
  cursor: not-allowed !important;
}

.MedicalProblemPopup-module__absolute-centered___EXSN3 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MedicalProblemPopup-module__absolute___NyyWW {
  position: absolute;
}

.MedicalProblemPopup-module__relative___MV1ER {
  position: relative;
}

.MedicalProblemPopup-module__fixed___kVyXb {
  position: fixed;
}

.MedicalProblemPopup-module__visible___fgGLM {
  opacity: 1;
}

.MedicalProblemPopup-module__invisible___RtdzT {
  opacity: 0;
}

.MedicalProblemPopup-module__col-90___ggCPf {
  width: 90% !important;
}

.MedicalProblemPopup-module__col-auto___oOkfs {
  width: auto !important;
}

.MedicalProblemPopup-module__medical-tabs___fpNiR {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MedicalProblemPopup-module__medical-table-new___JnzhY {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MedicalProblemPopup-module__medical-table-new___JnzhY:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MedicalProblemPopup-module__medical-table-new___JnzhY::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MedicalProblemPopup-module__medical-table-new___JnzhY::-webkit-scrollbar-track {
  display: none;
}
.MedicalProblemPopup-module__medical-table-new___JnzhY.MedicalProblemPopup-module__no-pagination___iVNMs {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MedicalProblemPopup-module__medical-table-new___JnzhY.MedicalProblemPopup-module__no-pagination___iVNMs:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MedicalProblemPopup-module__medical-table-new___JnzhY.MedicalProblemPopup-module__no-pagination___iVNMs::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MedicalProblemPopup-module__medical-table-new___JnzhY.MedicalProblemPopup-module__no-pagination___iVNMs::-webkit-scrollbar-track {
  display: none;
}

.MedicalProblemPopup-module__medical-table-empty___C990q {
  padding: 14px 40px !important;
}

.MedicalProblemPopup-module__icon-btn___CSmQj {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MedicalProblemPopup-module__search-icon___XPI4n {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MedicalProblemPopup-module__disable-select___H8ap2 {
  user-select: none;
}

.MedicalProblemPopup-module__break-word___OlJhT {
  word-break: break-word;
}

.MedicalProblemPopup-module__popup-clear-btn___bc2tm {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MedicalProblemPopup-module__scroll-m-b-20___vE8ht {
  scroll-margin-bottom: 20px;
}

.MedicalProblemPopup-module__container___o44Gm {
  flex: 1;
  padding: 20px 30px;
}
.MedicalProblemPopup-module__container___o44Gm .MedicalProblemPopup-module__autocomplete___cyvhQ {
  width: 50%;
}
.MedicalProblemPopup-module__container___o44Gm .MedicalProblemPopup-module__select___GFbjT {
  width: 205px;
}
.MedicalProblemPopup-module__container___o44Gm .MedicalProblemPopup-module__item___CZEll {
  flex: 1;
  padding: 10px 0 25px 0;
}
.MedicalProblemPopup-module__container___o44Gm .MedicalProblemPopup-module__dateWrapper___lQCmM {
  width: 33% !important;
}
.MedicalProblemPopup-module__container___o44Gm .MedicalProblemPopup-module__buttonsContainer___XxoZ0 {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding-top: 19px;
  gap: 16px;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/MedicalProblemPopup/MedicalProblemPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,UAAA;AA8pBJ;AA3pBE;EACE,YAAA;AA6pBJ;AA1pBE;EACE,OAAA;EACA,sBAAA;AA4pBJ;AAzpBE;EACE,qBAAA;AA2pBJ;AAxpBE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,SAAA;EACA,2CAAA;AA0pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  padding: 20px 30px;\n\n  .autocomplete {\n    width: 50%;\n  }\n\n  .select {\n    width: 205px;\n  }\n\n  .item {\n    flex: 1;\n    padding: 10px 0 25px 0;\n  }\n\n  .dateWrapper {\n    width: 33% !important;\n  }\n\n  .buttonsContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    padding-top: 19px;\n    gap: 16px;\n    border-top: 1px solid rgba(91, 91, 91, 0.2);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MedicalProblemPopup-module__font-s-10___YPlx4`,
	"fontS12": `MedicalProblemPopup-module__font-s-12___cq9Fn`,
	"fontS13": `MedicalProblemPopup-module__font-s-13___Fdf6N`,
	"fontS14": `MedicalProblemPopup-module__font-s-14___QWgOZ`,
	"fontS15": `MedicalProblemPopup-module__font-s-15___A5iGT`,
	"fontS16": `MedicalProblemPopup-module__font-s-16___cl4Cw`,
	"fontS18": `MedicalProblemPopup-module__font-s-18___eBVfG`,
	"fontS20": `MedicalProblemPopup-module__font-s-20___emEcS`,
	"fontS22": `MedicalProblemPopup-module__font-s-22___W5fTm`,
	"fontS28": `MedicalProblemPopup-module__font-s-28___sTtrM`,
	"fontW400": `MedicalProblemPopup-module__font-w-400___x2Tz8`,
	"fontW500": `MedicalProblemPopup-module__font-w-500___SFJap`,
	"fontW600": `MedicalProblemPopup-module__font-w-600___S8OX6`,
	"fontW700": `MedicalProblemPopup-module__font-w-700___ffwWb`,
	"p5": `MedicalProblemPopup-module__p-5___U9szd`,
	"p12": `MedicalProblemPopup-module__p-12___s97tM`,
	"p16": `MedicalProblemPopup-module__p-16___z2buJ`,
	"p30": `MedicalProblemPopup-module__p-30___Hg4e7`,
	"pB0": `MedicalProblemPopup-module__p-b-0___ufGGw`,
	"pB5": `MedicalProblemPopup-module__p-b-5___T3Tyl`,
	"pB10": `MedicalProblemPopup-module__p-b-10___QyVZg`,
	"pB12": `MedicalProblemPopup-module__p-b-12___NXY7E`,
	"pB16": `MedicalProblemPopup-module__p-b-16___ZlIPl`,
	"pB18": `MedicalProblemPopup-module__p-b-18___rL2Qt`,
	"pB20": `MedicalProblemPopup-module__p-b-20___agklF`,
	"pB25": `MedicalProblemPopup-module__p-b-25___hMexT`,
	"pB30": `MedicalProblemPopup-module__p-b-30___ll_Yd`,
	"pB50": `MedicalProblemPopup-module__p-b-50___aWlta`,
	"pT0": `MedicalProblemPopup-module__p-t-0___mkenR`,
	"pT12": `MedicalProblemPopup-module__p-t-12___cpvfX`,
	"pT16": `MedicalProblemPopup-module__p-t-16___ILABN`,
	"pT18": `MedicalProblemPopup-module__p-t-18___fFK0G`,
	"pT20": `MedicalProblemPopup-module__p-t-20___v1DcL`,
	"pT30": `MedicalProblemPopup-module__p-t-30___NiMdm`,
	"pT40": `MedicalProblemPopup-module__p-t-40___cWY7s`,
	"pT50": `MedicalProblemPopup-module__p-t-50___fj0_H`,
	"pL20": `MedicalProblemPopup-module__p-l-20___YbfT5`,
	"pL30": `MedicalProblemPopup-module__p-l-30___mUGns`,
	"pL40": `MedicalProblemPopup-module__p-l-40___a9ISR`,
	"pR16": `MedicalProblemPopup-module__p-r-16___zsfa0`,
	"pR20": `MedicalProblemPopup-module__p-r-20___fA956`,
	"pR30": `MedicalProblemPopup-module__p-r-30___hSm15`,
	"pR50": `MedicalProblemPopup-module__p-r-50___NjMOQ`,
	"pR60": `MedicalProblemPopup-module__p-r-60___fSuEi`,
	"mB1": `MedicalProblemPopup-module__m-b-1___wotsX`,
	"mB2": `MedicalProblemPopup-module__m-b-2___AQzp8`,
	"mB6": `MedicalProblemPopup-module__m-b-6___fNGf_`,
	"mB8": `MedicalProblemPopup-module__m-b-8___IosPo`,
	"mB10": `MedicalProblemPopup-module__m-b-10___LYdr8`,
	"mB14": `MedicalProblemPopup-module__m-b-14___fp6c4`,
	"mB16": `MedicalProblemPopup-module__m-b-16____4kTB`,
	"mB20": `MedicalProblemPopup-module__m-b-20___vEx5s`,
	"mB22": `MedicalProblemPopup-module__m-b-22___klrzw`,
	"mB24": `MedicalProblemPopup-module__m-b-24___XDHAF`,
	"mB30": `MedicalProblemPopup-module__m-b-30___X5XIB`,
	"mB32": `MedicalProblemPopup-module__m-b-32___GqtnS`,
	"mB40": `MedicalProblemPopup-module__m-b-40___jUrer`,
	"mT2": `MedicalProblemPopup-module__m-t-2____lHkg`,
	"mT3": `MedicalProblemPopup-module__m-t-3___HcS6E`,
	"mT4": `MedicalProblemPopup-module__m-t-4___nL32O`,
	"mT5": `MedicalProblemPopup-module__m-t-5___99bQN`,
	"mT8": `MedicalProblemPopup-module__m-t-8___g56Iz`,
	"mT10": `MedicalProblemPopup-module__m-t-10___zbdNC`,
	"mT15": `MedicalProblemPopup-module__m-t-15___xFmG8`,
	"mT16": `MedicalProblemPopup-module__m-t-16___ek40z`,
	"mT20": `MedicalProblemPopup-module__m-t-20___yxppV`,
	"mT22": `MedicalProblemPopup-module__m-t-22___FzPat`,
	"mT30": `MedicalProblemPopup-module__m-t-30___mcnRa`,
	"mT32": `MedicalProblemPopup-module__m-t-32___UiOY0`,
	"mLAuto": `MedicalProblemPopup-module__m-l-auto___dbDWu`,
	"mL4": `MedicalProblemPopup-module__m-l-4___ke4cR`,
	"mL5": `MedicalProblemPopup-module__m-l-5___rItU7`,
	"mL6": `MedicalProblemPopup-module__m-l-6___znOJB`,
	"mL8": `MedicalProblemPopup-module__m-l-8___V7DHM`,
	"mL10": `MedicalProblemPopup-module__m-l-10___xHdYU`,
	"mL16": `MedicalProblemPopup-module__m-l-16___ygEca`,
	"mL20": `MedicalProblemPopup-module__m-l-20___qm7JZ`,
	"mL24": `MedicalProblemPopup-module__m-l-24___MliXi`,
	"mL30": `MedicalProblemPopup-module__m-l-30___PaEKW`,
	"mL35": `MedicalProblemPopup-module__m-l-35___VbvoL`,
	"mL40": `MedicalProblemPopup-module__m-l-40___UsRim`,
	"mR8": `MedicalProblemPopup-module__m-r-8___t9Mbt`,
	"mR10": `MedicalProblemPopup-module__m-r-10___QEE_3`,
	"mR16": `MedicalProblemPopup-module__m-r-16___ZajIW`,
	"mR20": `MedicalProblemPopup-module__m-r-20___Y3VzB`,
	"mR24": `MedicalProblemPopup-module__m-r-24___djewP`,
	"mR30": `MedicalProblemPopup-module__m-r-30___Zwiv5`,
	"mR40": `MedicalProblemPopup-module__m-r-40___NCrzb`,
	"borderR3": `MedicalProblemPopup-module__border-r-3___fzTXP`,
	"borderR4": `MedicalProblemPopup-module__border-r-4___PAo9U`,
	"borderR6": `MedicalProblemPopup-module__border-r-6___arN3L`,
	"borderR10": `MedicalProblemPopup-module__border-r-10___qNO4Y`,
	"borderR12": `MedicalProblemPopup-module__border-r-12___s_lIJ`,
	"borderR16": `MedicalProblemPopup-module__border-r-16___h5zjx`,
	"borderR50": `MedicalProblemPopup-module__border-r-50___TLJjj`,
	"primaryBorder": `MedicalProblemPopup-module__primary-border___XnWD5`,
	"primaryBorderB": `MedicalProblemPopup-module__primary-border-b___FSive`,
	"primaryBorderT": `MedicalProblemPopup-module__primary-border-t___mR7C7`,
	"primaryBorderL": `MedicalProblemPopup-module__primary-border-l___Ym7Dz`,
	"primaryBorderR": `MedicalProblemPopup-module__primary-border-r___X5zvl`,
	"secondaryBorder": `MedicalProblemPopup-module__secondary-border___u8xC7`,
	"secondaryBorderB": `MedicalProblemPopup-module__secondary-border-b___q9sd_`,
	"secondaryBorderT": `MedicalProblemPopup-module__secondary-border-t___t3CCK`,
	"secondaryBorderL": `MedicalProblemPopup-module__secondary-border-l___ABZjI`,
	"secondaryBorderR": `MedicalProblemPopup-module__secondary-border-r___xU5fR`,
	"gap0": `MedicalProblemPopup-module__gap-0___MlNEm`,
	"gap2": `MedicalProblemPopup-module__gap-2___KFMrz`,
	"gap4": `MedicalProblemPopup-module__gap-4___EZvr6`,
	"gap5": `MedicalProblemPopup-module__gap-5___Wx6lF`,
	"gap6": `MedicalProblemPopup-module__gap-6___dD0CU`,
	"gap8": `MedicalProblemPopup-module__gap-8____n72u`,
	"gap10": `MedicalProblemPopup-module__gap-10___INw7x`,
	"gap12": `MedicalProblemPopup-module__gap-12___yFn4a`,
	"gap14": `MedicalProblemPopup-module__gap-14___WEX9A`,
	"gap16": `MedicalProblemPopup-module__gap-16___spqrq`,
	"gap18": `MedicalProblemPopup-module__gap-18___ryDnL`,
	"gap20": `MedicalProblemPopup-module__gap-20___MXFBZ`,
	"gap24": `MedicalProblemPopup-module__gap-24___YdNQU`,
	"gap26": `MedicalProblemPopup-module__gap-26___BdPgg`,
	"gap30": `MedicalProblemPopup-module__gap-30___rlOki`,
	"gap32": `MedicalProblemPopup-module__gap-32___JAMyv`,
	"gap40": `MedicalProblemPopup-module__gap-40___s6_m7`,
	"gap50": `MedicalProblemPopup-module__gap-50___S4qlp`,
	"flex1": `MedicalProblemPopup-module__flex-1___sP7eh`,
	"flexNone": `MedicalProblemPopup-module__flex-none___nDAIh`,
	"flexColumn": `MedicalProblemPopup-module__flex-column___CpjnU`,
	"flexRow": `MedicalProblemPopup-module__flex-row___KoMAQ`,
	"verticallyCentered": `MedicalProblemPopup-module__vertically-centered___tFMjH`,
	"horizontallyCentered": `MedicalProblemPopup-module__horizontally-centered___LADrO`,
	"horizontallyEnd": `MedicalProblemPopup-module__horizontally-end___xSCay`,
	"verticallyStart": `MedicalProblemPopup-module__vertically-start___fgaBt`,
	"spaceBetween": `MedicalProblemPopup-module__space-between___kG3kb`,
	"flexWrap": `MedicalProblemPopup-module__flex-wrap___UWxy4`,
	"height100": `MedicalProblemPopup-module__height-100___e33Tu`,
	"width50": `MedicalProblemPopup-module__width-50___vo0eU`,
	"width100": `MedicalProblemPopup-module__width-100___noaVO`,
	"cursorPointer": `MedicalProblemPopup-module__cursor-pointer___i8X3e`,
	"cursorNotAllowed": `MedicalProblemPopup-module__cursor-not-allowed___x0e0g`,
	"absoluteCentered": `MedicalProblemPopup-module__absolute-centered___EXSN3`,
	"absolute": `MedicalProblemPopup-module__absolute___NyyWW`,
	"relative": `MedicalProblemPopup-module__relative___MV1ER`,
	"fixed": `MedicalProblemPopup-module__fixed___kVyXb`,
	"visible": `MedicalProblemPopup-module__visible___fgGLM`,
	"invisible": `MedicalProblemPopup-module__invisible___RtdzT`,
	"col90": `MedicalProblemPopup-module__col-90___ggCPf`,
	"colAuto": `MedicalProblemPopup-module__col-auto___oOkfs`,
	"medicalTabs": `MedicalProblemPopup-module__medical-tabs___fpNiR`,
	"medicalTableNew": `MedicalProblemPopup-module__medical-table-new___JnzhY`,
	"noPagination": `MedicalProblemPopup-module__no-pagination___iVNMs`,
	"medicalTableEmpty": `MedicalProblemPopup-module__medical-table-empty___C990q`,
	"iconBtn": `MedicalProblemPopup-module__icon-btn___CSmQj`,
	"searchIcon": `MedicalProblemPopup-module__search-icon___XPI4n`,
	"disableSelect": `MedicalProblemPopup-module__disable-select___H8ap2`,
	"breakWord": `MedicalProblemPopup-module__break-word___OlJhT`,
	"popupClearBtn": `MedicalProblemPopup-module__popup-clear-btn___bc2tm`,
	"scrollMB20": `MedicalProblemPopup-module__scroll-m-b-20___vE8ht`,
	"container": `MedicalProblemPopup-module__container___o44Gm`,
	"autocomplete": `MedicalProblemPopup-module__autocomplete___cyvhQ`,
	"select": `MedicalProblemPopup-module__select___GFbjT`,
	"item": `MedicalProblemPopup-module__item___CZEll`,
	"dateWrapper": `MedicalProblemPopup-module__dateWrapper___lQCmM`,
	"buttonsContainer": `MedicalProblemPopup-module__buttonsContainer___XxoZ0`
};
module.exports = ___CSS_LOADER_EXPORT___;
